export const SWITCH_GRAPH_TYPE = 'SWITCH_GRAPH_TYPE';

export const switchGraphType = (newGraphType) => ({
  type: SWITCH_GRAPH_TYPE,
  payload: newGraphType,
});
